import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent, DxTextBoxComponent } from 'devextreme-angular';
import { RowInsertedEvent, RowUpdatingEvent, RowRemovingEvent } from 'devextreme/ui/data_grid';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { TenantChannelUpdateModel } from 'src/app/models/tenants/tenant-channel-update.model';
import { TenantChannelModel } from 'src/app/models/tenants/tenant-channel.model';
import { LoadingService } from 'src/app/services/loading.service';
import { TenantChannelService } from 'src/app/services/tenants/tenant-channel.service';

@Component({
  selector: 'app-marketing-channels',
  standalone: false,
  templateUrl: './marketing-channels.component.html',
  styleUrl: './marketing-channels.component.scss',
})
export class MarketingChannelsComponent {
  @ViewChild('channelsGrid')
  channelsGrid!: DxDataGridComponent;

  @ViewChild('searchBoxInput')
  searchBoxInput!: DxTextBoxComponent;

  channelEditPopupTitle = '';
  searchValue = '';
  
  marketingChannels$!: Observable<TenantChannelModel[]>;

  constructor(
    private tenantChannelService: TenantChannelService,
    private loadingService: LoadingService,
    private toastrService: ToastrService,
    private translateService: TranslateService
  ) {
  }

  ngOnInit() {
    this.loadChannels();
  }

  onAddChannelClick(): void {
    this.channelsGrid.instance.addRow();
  }

  onChannelAddingStart(): void {
    this.channelEditPopupTitle = this.translateService.instant(
      'CHANNELS.ADD-CHANNEL.TITLE'
    );
  }

  onChannelEditingStart(): void {
    this.channelEditPopupTitle = this.translateService.instant(
      'CHANNELS.UPDATE-CHANNEL.TITLE'
    );
  }

  onChannelInserted(e: RowInsertedEvent): void {
    const model: TenantChannelUpdateModel = {
      name: e.data.name,
    };

    this.loadingService
      .load(this.tenantChannelService.addTenantChannel(model))
      .subscribe(() => {
        this.toastrService.success(
          this.translateService.instant(
            'CHANNELS.ADD-CHANNEL.ADDED-CHANNEL-SUCCESSFULLY'
          )
        );
        this.loadChannels();
      });
  }

  onChannelUpdating(e: RowUpdatingEvent): void {
    const model: TenantChannelUpdateModel = {
      name: e.newData.name,
    };

    this.loadingService
      .load(this.tenantChannelService.updateTenantChannel(e.key, model))
      .subscribe(() => {
        this.toastrService.success(
          this.translateService.instant(
            'CHANNELS.UPDATE-CHANNEL.UPDATED-CHANNEL-SUCCESSFULLY'
          )
        );
      });
  }

  onChannelRemoving(e: RowRemovingEvent): void {
    this.loadingService
      .load(this.tenantChannelService.deleteTenantChannel(e.key))
      .subscribe(() => {
        this.toastrService.success(
          this.translateService.instant(
            'CHANNELS.DELETE-CHANNEL.DELETED-CHANNEL-SUCCESSFULLY'
          )
        );
      });
  }

  onChannelSearch(event: any): void {
    this.searchValue = event.value;
    this.channelsGrid.instance.searchByText(event.value);

    setTimeout(() => {
      // @ts-ignore
      this.searchBoxInput!.instance!.focus();
    }, 100);
  }

  private loadChannels(): void {
    this.marketingChannels$ = this.loadingService.load(
      this.tenantChannelService.getExternalTenantChannels()
    );
  }
}
